import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentPage } from "@/components/legal/legal-document-page";

export const Route = createFileRoute("/termos")({
  head: () => ({
    meta: [
      { title: "Innovally — Termos de Uso" },
      {
        name: "description",
        content:
          "Condições de uso do aplicativo e da plataforma Innovally para lojistas, sublojistas e motoboys.",
      },
      { property: "og:title", content: "Innovally — Termos de Uso" },
      {
        property: "og:description",
        content: "Regras de uso do aplicativo e da plataforma Innovally.",
      },
      { property: "og:type", content: "website" },
    ],
  }),
  component: () => <LegalDocumentPage documentId="terms" />,
});
